<template>
    <div>
        <div class="row m-2 bg-white p-1 rounded">
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('wallets.label.withdraw_type') }}</div>
                <input class="form-control"
                       :value="withdrawTypeStr.get(settlement_withdraw_type)"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.total_amount') }}</div>
                <input class="form-control"
                       :value="total_amount"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.status') }}</div>
                <input :class="`form-control text-white bg-${walletTransactionStatusVariant(status)}`"
                       :value="walletTransactionStatusStr.get(status)"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2"
                 v-if="error_message !== ''"
            >
                <div>{{ $t('label.error') }}</div>
                <input class="form-control"
                       :value="error_message"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2"
                 v-if="ref_code !== ''"
            >
                <div>{{ $t('label.ref_code') }}</div>
                <input class="form-control"
                       :value="ref_code"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2"
            >
                <div>{{ $t('label.description') }}</div>
                <input class="form-control"
                       :value="transfer_description"
                       disabled
                >
            </div>
        </div>

        <div>
            <table class="table table-bordered bg-white">
                <tr>
                    <td v-text="$t('wallets.label.destination_owner_name')"></td>
                    <td v-text="$t('wallets.label.destination_deposit')"></td>
                    <td v-text="$t('label.amount_rial')"></td>
                </tr>
                <tr>
                    <td v-text="destination_name"></td>
                    <td v-text="settlement_data.destination_number"></td>
                    <td v-text="settlement_data.amount"></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import {withdrawType, withdrawTypeStr} from "@/constants/withdrawType";
    import {walletTransactionStatus, walletTransactionStatusStr, walletTransactionStatusVariant} from "@/constants/walletTransactionStatus";

    export default {
        data() {
            return {
                withdrawType,
                withdrawTypeStr,
                walletTransactionStatus,
                walletTransactionStatusStr,
                walletTransactionStatusVariant,
            }
        },
        computed: {
            destination_name() {
                return this.settlement_data.destination_firstname + ' ' + this.settlement_data.destination_lastname;
            },
        },
        props: {
            settlement_withdraw_type: {
                required: true,
            },
            settlement_data: {
                required: true,
            },
            total_amount: {
                required: true,
            },
            status: {
                required: true,
            },
            error_message: {
                required: true,
            },
            ref_code: {
                required: true,
            },
            transfer_description: {
                required: true
            }
        },
    }
</script>
